module.exports = __webpack_public_path__ + "fb3c0d764724b0f833d60928321b2545.MP3";